<template>
  <div
    class="c-openinghours"
    :class="{ 'c-openinghours--negative': negative }"
    v-click-away="closeHours"
  >
    <slot name="hours"></slot>
    <div class="c-openinghours__button" @click="isOpen = !isOpen" v-if="!float">
      <iInfo />
    </div>
    <transition name="fade">
      <div v-if="isOpen" class="c-openinghours__list">
        <slot name="list"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

//SVG
import iInfo from '@web/assets/icon/info.svg';

export default defineComponent({
  name: 'c-openinghours',
  components: {
    iInfo,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    negative: Boolean,
    float: Boolean,
  },
  methods: {
    closeHours() {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
  },
});
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-openinghours {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  &__button {
    display: flex;
    align-items: center;
    margin-left: 5px;
    cursor: pointer;

    svg {
      width: 18px;
      height: 18px;
      path {
        transition: $t-hover;
      }
    }

    &:hover {
      svg {
        path {
          transition: $t-hover;
          fill: $c-red;
        }
      }
    }
  }

  &__list {
    z-index: 20;
    position: absolute;
    top: 30px;
    left: -10px;
    width: calc(100% + 20px);
    min-width: 225px;
    background-color: $c-white;
    border-radius: 10px;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  &--negative {
    svg {
      path {
        fill: $c-white;
      }
    }
  }
}
</style>
